import { colors } from '@giphy/react-giphy-brand'
import React from 'react'
import styled from 'styled-components'
import Empty from './empty'
import SuggestedTag from './suggested-tag'

const TagsWrapper = styled.ul`
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
    text-align: left;
    width: 100%;
    padding: 0px 10px;
    margin-bottom: 12px;
`

const TagsWrapperVertical = styled.ul`
    padding: 0 6px;

    li {
        margin-right: 0px;
        display: flex;
        margin-bottom: 6px;

        span:first-child {
            width: 100%;
        }
    }
`

const ClickDescriptionWrapper = styled.div`
    padding: 15px 15px 8px 15px;
    color: ${colors.giphyLightGrey};
    font-size: 14px;
    line-height: normal;
    font-weight: normal;

    i {
        font-size: 12px;
        display: inline-block;
        vertical-align: middle;
        margin-top: -2px;
    }
`

type Props = {
    suggestedTags: string[]
    onAdd: (tag: string) => void
    onDelete: (tag: string) => void
    isVertical: boolean
}

const SuggestedTagsList = ({ suggestedTags, onAdd, onDelete, isVertical }: Props) => {
    const Tags = isVertical ? TagsWrapperVertical : TagsWrapper
    return (
        <>
            {suggestedTags.length > 0 ? (
                <>
                    <Tags>
                        {suggestedTags.map(tag => (
                            <SuggestedTag
                                tag={tag}
                                onAdd={onAdd}
                                onDelete={onDelete}
                                key={tag}
                                isVertical={isVertical}
                            />
                        ))}
                    </Tags>
                    <ClickDescriptionWrapper>
                        <span>
                            Click tag to add or click <i className="ss-icon ss-delete" /> to mark as irrelevant.
                        </span>
                    </ClickDescriptionWrapper>
                </>
            ) : (
                <Empty />
            )}
        </>
    )
}

export default SuggestedTagsList
